// extracted by mini-css-extract-plugin
export default {"main-contain":"AdminLayout_main-contain__govkl","wrapper":"AdminLayout_wrapper__QzN-R","container":"AdminLayout_container__NA2As","content":"AdminLayout_content__L6ScH"};